import { h } from "@stencil/core";

import { ComboBoxModel } from "@genexus/chameleon-controls-library";
import { GxOption } from "../..";

export const mapOptionsToComboBoxItemModel = (
  options: GxOption[]
): ComboBoxModel => {
  return options.map(option => {
    return {
      value: option.id,
      caption: option.label,
      startImgSrc: option.iconName ?? ""
    };
  });
};

const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

export const hiChar = (text: string, search: string): Element[] | string => {
  if (!search) {
    return text;
  }
  const escapedSearch = escapeRegExp(search);
  const parts = text.split(new RegExp(`(${escapedSearch})`, "gi"));
  return parts.map((part, i) =>
    part.toLowerCase() === search.toLowerCase() ? (
      <span key={i} class="hiChar">
        {part}
      </span>
    ) : (
      part
    )
  );
};
